import { Box, Flex, Image, Text, useToast } from "native-base";
import React, { useState, useRef, useEffect } from "react";
import { widthPercentageToDP as wp } from "react-native-responsive-screen";
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons";

import createStyles from "./styles";

import { useTheme } from "../../../../ThemeProvider";

import { RFPercentage } from "react-native-responsive-fontsize";
import Api from "../../../../Api/Api";
import { useNavigation, useRoute } from "@react-navigation/native";
import Template from "../../../template/Index";
import Input from "../../../../components/Input";
import {
  FlatList,
  StyleSheet,
  Text as RNText,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { Feather } from "@expo/vector-icons";
import SkeletonItens from "../../../components/Skeleton/Itens";
import { useToastMessage } from "../../../hooks/useToastMessage";
import TemplateEtapas from "../../../template/Etapas/Index";
import { CORES, sombraCard } from "../../../template/Etapas/styles";
import { corComAlpha, corTextoSobre } from "../../../theme/cores";

const Pacotes: React.FC = () => {
  const { cor_rgba, getCodEmpresa, configEmpresa, primaryColor } = useTheme();
  const [pacoteSelecionadoNovo, setPacoteSelecionadoNovo] = useState<any>(null);
  const toast = useToast();

  const navigation = useNavigation();
  const refModal = useRef();
  const route = useRoute();

  const [pacotes, setPacotes] = useState<any[]>([]);
  const [pacotes_original, setPacotesOriginal] = useState<any[]>([]);
  const [filtro, setFiltro] = useState<String>("");
  const [buscando, setBuscando] = useState<boolean>(false);

  const [getConfigEmpresa, setConfigEmpresa] = useState<any>(
    JSON.parse(configEmpresa),
  );
  const { error } = useToastMessage();

  const styles = createStyles(getConfigEmpresa.coresPWA);

  useEffect(() => {
    getPacotesCliente(Number(getCodEmpresa));
  }, []);

  async function getPacotesCliente(id_empresa: number) {
    setBuscando(true);

    const servicos = await Api.pacotesCliente(
      id_empresa,
      route.params.idCliente,
    );

    if (!servicos.status) {
      error("Atenção", "Erro ao buscar Pacotes");
      setBuscando(false);
      return;
    }

    setPacotes(servicos.data);
    setPacotesOriginal(servicos.data);
    setBuscando(false);

    // navigation.navigate("PacoteItens", { pacoteSelecionado: servicos.data[0] });

    // setBuscando(false );
  }

  function filtrarPacotes(text: string) {
    setFiltro(text);
    const servicos_copy = [...pacotes_original];
    const servicos_filtrados = servicos_copy.filter((item) => {
      return item.pacote.descricao.toUpperCase().includes(text.toUpperCase());
    });
    setPacotes(servicos_filtrados);
  }

  function renderFiltro() {
    return (
      <Input
        type={"text"}
        icon={"search"}
        value={filtro}
        corBordaFiltro={getConfigEmpresa.coresPWA.corBordaFiltro}
        colorItem={getConfigEmpresa.coresPWA.corFonteFiltro}
        width={"100%"}
        onChangeText={filtrarPacotes}
        placeholder="Descrição"
        helperText="Informe a descrição do pacote"
      />
    );
  }

  function reotornaValidade(data: string) {
    const data_formatada = new Date(`${data}T00:00:00`);
    const dia = data_formatada.getDate();

    const mes = data_formatada.getMonth() + 1;
    const ano = data_formatada.getFullYear();

    const mes_formatado = mes < 10 ? `0${mes}` : mes;

    return `${dia}/${mes_formatado}/${ano}`;
  }

  function retornaLinhaDiaSemana(dia: string, item: any, numeroDia: number) {
    return (
      <Text
        style={{
          backgroundColor: item.diasValidade.includes(numeroDia)
            ? "green"
            : "red",
          color: "#fff",
          padding: 3,
          borderRadius: 5,
          // width: 20,
          textAlign: "center",
        }}
      >
        {dia}
      </Text>
    );
  }

  function linhaPacote(item: any) {
    const data_exibir = reotornaValidade(item.dataValidade);
    const valido = new Date(`${item.dataValidade}T23:59:00`);
    const data_maior = valido > new Date();

    const diasValidade =
      item.diasValidade != "" ? item.diasValidade.split(",") : [];

    return (
      <Flex style={styles.containerFlex}>
        <Box style={styles.leftFlex}>
          <Image
            source={{
              uri: "https://i.pinimg.com/originals/bf/5d/b5/bf5db5425b7823594844b3a110c58e0b.png",
            }}
            alt="Item"
            resizeMode="cover"
            style={styles.imageItem}
          />

          <Box>
            <Text
              style={[
                styles.itemTextWithMargin,
                { color: getConfigEmpresa.coresPWA.corFontePrimaria },
              ]}
              fontSize={"lg"}
            >
              {item.pacote.descricao}
            </Text>
            <Text
              style={[
                styles.itemTextWithMargin,
                {
                  color: data_maior
                    ? getConfigEmpresa.coresPWA.corTextoDisponivel
                    : getConfigEmpresa.coresPWA.corTextoIndisponivel,
                },
              ]}
              fontSize={"sm"}
            >
              {"Válido até: " + data_exibir}
            </Text>

            <Text
              style={[
                styles.itemTextWithMargin,
                {
                  color: getConfigEmpresa.coresPWA.corFontePrimaria,
                },
              ]}
              fontSize={"sm"}
            >
              Disponiveis P/ Utilização
            </Text>

            <Box
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginLeft: 10,
                marginTop: 4,
              }}
            >
              {retornaLinhaDiaSemana("S", item, 1)}
              {retornaLinhaDiaSemana("T", item, 2)}
              {retornaLinhaDiaSemana("Q", item, 3)}
              {retornaLinhaDiaSemana("Q", item, 4)}
              {retornaLinhaDiaSemana("S", item, 5)}
              {retornaLinhaDiaSemana("S", item, 6)}
              {retornaLinhaDiaSemana("D", item, 0)}
            </Box>
          </Box>
        </Box>

        <Flex style={styles.rightFlex}>
          <Text style={styles.itemText}>{`R$ ${item.valor}`}</Text>
        </Flex>

        {!data_maior && <Box style={styles.overlayBox}></Box>}
      </Flex>
    );
  }

  function onPressPacoteSelecionado(item: any) {
    const data_exibir = reotornaValidade(item.dataValidade);
    const valido = new Date(`${item.dataValidade}T23:59:00`);
    const data_maior = valido > new Date();

    if (!data_maior) {
      return;
    }

    navigation.navigate("PacoteItens", { pacoteSelecionado: item });
  }

  const renderItem = ({ item, index }) => (
    <TouchableOpacity
      key={index}
      style={[
        styles.pressableItem,
        {
          borderColor: item.selecionado
            ? (cor_rgba ?? "defaultColor")
            : getConfigEmpresa.coresPWA.corBordaItens,
        }, //mais clara
      ]}
      onPress={() => onPressPacoteSelecionado(item)}
    >
      {buscando ? <SkeletonItens /> : linhaPacote(item)}
    </TouchableOpacity>
  );

  const renderEmptyComponent = () => (
    <Box alignItems="center" justifyContent="center" mt={10}>
      <MaterialCommunityIcons
        name="database-remove"
        size={80}
        color={getConfigEmpresa.coresPWA.corFontePrimaria}
        style={{ marginBottom: 16 }}
      />
      <Text
        style={{
          textAlign: "center",
          fontSize: RFPercentage(2.5),
          color: getConfigEmpresa.coresPWA.corFontePrimaria,
        }}
      >
        Nenhum registro encontrado.
      </Text>
    </Box>
  );

  // ---------------- Layout novo ----------------
  // O modo legado (pwa simples / layout v2 / tema escuro) continua com o template antigo
  const utilizaLayoutLegado =
    getConfigEmpresa.utilizaPwaSimples ||
    getConfigEmpresa.versaoPWA == 2 ||
    getConfigEmpresa.utilizaTemaEscuro;

  const corPrincipal: string = primaryColor || "#006400";
  const corTextoPrincipal = corTextoSobre(corPrincipal);

  const DIAS_USO = [
    { letra: "S", numero: 1 },
    { letra: "T", numero: 2 },
    { letra: "Q", numero: 3 },
    { letra: "Q", numero: 4 },
    { letra: "S", numero: 5 },
    { letra: "S", numero: 6 },
    { letra: "D", numero: 0 },
  ];

  function formatarValor(valor: any) {
    return Number(valor || 0).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }

  function pacoteValido(item: any) {
    return new Date(`${item.dataValidade}T23:59:00`) > new Date();
  }

  function renderBuscaNova() {
    return (
      <View style={[stylesNovo.busca, sombraCard]}>
        <Feather name="search" size={17} color={CORES.subtitulo} />
        <TextInput
          value={String(filtro || "")}
          onChangeText={filtrarPacotes}
          placeholder="Buscar pacote"
          placeholderTextColor={CORES.subtitulo}
          style={stylesNovo.inputBusca as any}
        />
      </View>
    );
  }

  function renderCardPacote(item: any, index: number) {
    const valido = pacoteValido(item);
    const selecionado = pacoteSelecionadoNovo?.id === item.id;
    const diasValidade = String(item.diasValidade || "")
      .split(",")
      .map((dia) => dia.trim());

    return (
      <TouchableOpacity
        key={item.id ?? index}
        activeOpacity={0.85}
        disabled={!valido}
        onPress={() => {
          // o toque já avança; o botão do rodapé fica para quando o cliente voltar
          setPacoteSelecionadoNovo(item);
          onPressPacoteSelecionado(item);
        }}
        style={[
          stylesNovo.card,
          sombraCard,
          selecionado && {
            borderColor: corPrincipal,
            backgroundColor: corComAlpha(corPrincipal, 0.06),
          },
          !valido && { opacity: 0.5 },
        ]}
      >
        <View style={stylesNovo.linhaPrincipal}>
          <View
            style={[
              stylesNovo.icone,
              {
                backgroundColor: selecionado
                  ? corComAlpha(corPrincipal, 0.12)
                  : "#EFE9DF",
              },
            ]}
          >
            <Feather name="package" size={20} color={corPrincipal} />
          </View>

          <View style={{ flex: 1 }}>
            <RNText style={stylesNovo.nome} numberOfLines={2}>
              {item.pacote.descricao}
            </RNText>
            <RNText
              style={[
                stylesNovo.validade,
                !valido && { color: "#C0392B" },
              ]}
            >
              {(valido ? "Válido até " : "Venceu em ") +
                reotornaValidade(item.dataValidade)}
            </RNText>
          </View>

          <RNText
            style={[stylesNovo.valor, selecionado && { color: corPrincipal }]}
          >
            {formatarValor(item.valor)}
          </RNText>

          <View
            style={[
              stylesNovo.radio,
              selecionado && {
                backgroundColor: corPrincipal,
                borderColor: corPrincipal,
              },
            ]}
          >
            {selecionado && (
              <Feather name="check" size={14} color={corTextoPrincipal} />
            )}
          </View>
        </View>

        <View style={stylesNovo.linhaDias}>
          <RNText style={stylesNovo.rotuloDias}>Dias de uso</RNText>
          <View style={stylesNovo.dias}>
            {DIAS_USO.map((dia, indice) => {
              const permitido = diasValidade.includes(String(dia.numero));

              return (
                <View
                  key={indice}
                  style={[
                    stylesNovo.dia,
                    {
                      backgroundColor: permitido
                        ? corComAlpha(corPrincipal, 0.12)
                        : "rgba(0,0,0,0.04)",
                    },
                  ]}
                >
                  <RNText
                    style={[
                      stylesNovo.letraDia,
                      permitido
                        ? { color: corPrincipal }
                        : stylesNovo.letraDiaBloqueado,
                    ]}
                  >
                    {dia.letra}
                  </RNText>
                </View>
              );
            })}
          </View>
        </View>
      </TouchableOpacity>
    );
  }

  if (!utilizaLayoutLegado) {
    return (
      <TemplateEtapas
        ref={refModal}
        rotuloEtapa="Área do cliente"
        titulo="Seus pacotes"
        subtitulo="Escolha um pacote para usar no agendamento."
        filtro={renderBuscaNova()}
        ocultarFechar
        onVoltarClick={() => navigation.goBack()}
        resumoRotulo={pacoteSelecionadoNovo?.pacote?.descricao}
        resumoValor={
          pacoteSelecionadoNovo
            ? formatarValor(pacoteSelecionadoNovo.valor)
            : "Nenhum pacote"
        }
        desabilitarBotao={!pacoteSelecionadoNovo}
        onBotaoClick={() => {
          if (!pacoteSelecionadoNovo) {
            error("Atenção", "Por favor, selecione um pacote!");
            return;
          }
          onPressPacoteSelecionado(pacoteSelecionadoNovo);
        }}
      >
        {buscando ? (
          <SkeletonItens />
        ) : pacotes.length === 0 ? (
          <View style={stylesNovo.vazio}>
            <Feather name="package" size={40} color={CORES.subtitulo} />
            <RNText style={stylesNovo.textoVazio}>
              Nenhum pacote encontrado.
            </RNText>
          </View>
        ) : (
          pacotes.map((item, index) => renderCardPacote(item, index))
        )}
      </TemplateEtapas>
    );
  }

  // ---------------- Layout legado ----------------
  return (
    <Template
      titulo={"Seus Pacotes"}
      messageAlerta="Nesta tela você pode visualizar os seus pacotes disponíveis"
      ocultarBotaoCancelar
      onBotaoProximoClick={() => {
        error("Atenção", "Por favor, selecione um pacote!");
      }}
      onBotaoVoltarClick={() => {
        navigation.goBack();
      }}
      filtro={renderFiltro()}
      ref={refModal}
    >
      <Box style={styles.mainContainer}>
        <FlatList
          data={pacotes}
          renderItem={renderItem}
          ListEmptyComponent={
            buscando ? <SkeletonItens /> : renderEmptyComponent
          }
          keyExtractor={(item, index) => index.toString()}
          contentContainerStyle={{
            width: wp("98%"),
          }}
        />
      </Box>
    </Template>
  );
};

const stylesNovo = StyleSheet.create({
  busca: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    height: 48,
    paddingHorizontal: 14,
    borderRadius: 14,
    backgroundColor: CORES.card,
    borderWidth: 1,
    borderColor: CORES.borda,
  },
  inputBusca: {
    flex: 1,
    height: "100%",
    fontSize: 15,
    color: CORES.titulo,
    outlineStyle: "none",
  },
  card: {
    padding: 14,
    marginBottom: 12,
    borderRadius: 18,
    backgroundColor: CORES.card,
    borderWidth: 1.5,
    borderColor: "transparent",
  },
  linhaPrincipal: {
    flexDirection: "row",
    alignItems: "center",
    gap: 12,
  },
  icone: {
    width: 48,
    height: 48,
    borderRadius: 14,
    alignItems: "center",
    justifyContent: "center",
  },
  nome: {
    fontSize: 16,
    fontWeight: "700",
    color: CORES.titulo,
  },
  validade: {
    fontSize: 12,
    color: CORES.subtitulo,
    marginTop: 2,
  },
  valor: {
    fontSize: 15,
    fontWeight: "800",
    color: CORES.titulo,
  },
  radio: {
    width: 24,
    height: 24,
    borderRadius: 12,
    borderWidth: 1.5,
    borderColor: "#cfcfcf",
    alignItems: "center",
    justifyContent: "center",
  },
  linhaDias: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 12,
    paddingTop: 12,
    borderTopWidth: 1,
    borderTopColor: CORES.borda,
  },
  rotuloDias: {
    fontSize: 12,
    color: CORES.subtitulo,
  },
  dias: {
    flexDirection: "row",
    gap: 4,
  },
  dia: {
    width: 22,
    height: 22,
    borderRadius: 6,
    alignItems: "center",
    justifyContent: "center",
  },
  letraDia: {
    fontSize: 11,
    fontWeight: "700",
  },
  letraDiaBloqueado: {
    color: "#c7c2b8",
    textDecorationLine: "line-through",
  },
  vazio: {
    alignItems: "center",
    paddingVertical: 40,
    gap: 12,
  },
  textoVazio: {
    fontSize: 15,
    color: CORES.subtitulo,
  },
});

export default Pacotes;
